import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@fuww/library/src/List/index';
import {
  FooterTitle,
  Footer,
  Mini,
  FooterListItem,
  StyledAnchor,
  SubContainer,
  StyledDiv,
} from '@fuww/library/src/Footer';
import { MessageDescriptor, useIntl } from 'react-intl';
import OpenInNewIcon from '@fuww/library/src/Icons/OpenInNew';
import IconContainer from '@fuww/library/src/IconContainer';
import messages from '../lib/messages.mjs';
import getCurrentYear from '../lib/getCurrentYear';
import getFooterList from '../data/footer';
import { useSiteContext } from './SiteContext';
import { Link } from '../routes.mjs';
import { Item } from '../data/drawer';

interface SimpleListProperties {
  list: Item[];
}

const SimpleList = ({ list } : SimpleListProperties) => {
  const intl = useIntl();
  return (
    <List>
      {list.map(({
        id,
        name,
        href: originalHref,
        route,
        params,
        router,
        target,
        ...properties
      }) => {
        const hrefKey = `${id}.href`;
        const hrefTranslation = messages[
          hrefKey
        ] as MessageDescriptor | undefined;
        const href = hrefTranslation
          ? intl.formatMessage(hrefTranslation) : originalHref;

        return (
          <FooterListItem key={id}>
            {router ? (
              <Link
                route={route}
                params={params}
                passHref
              >
                <StyledAnchor
                  styled
                  target={target}
                  {...properties}
                >
                  {intl.formatMessage(messages[id])}
                </StyledAnchor>
              </Link>
            ) : (
              <StyledAnchor
                href={href}
                styled
                target={target}
                {...properties}
              >
                {intl.formatMessage(messages[id])}
                {target === '_blank' && (
                <IconContainer>
                  <OpenInNewIcon
                    title={intl.formatMessage(messages.openInNew)}
                    size={12}
                  />
                </IconContainer>
                )}
              </StyledAnchor>
            )}
          </FooterListItem>
        );
      })}
    </List>
  );
};

SimpleList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({})),
};

SimpleList.defaultProps = {
  list: [],
};

const FooterGrid = () => {
  const intl = useIntl();
  const {
    newsboard, board, hasLocalNews, locale, hasNews,
  } = useSiteContext();

  return (
    <SubContainer>
      {getFooterList(
        newsboard, board, hasLocalNews, intl, locale, hasNews,
      ).map(({
        id,
        list,
      }) => (
        <StyledDiv key={id}>
          <FooterTitle tag="div">
            {intl.formatMessage(messages[id])}
          </FooterTitle>
          <SimpleList list={list} />
        </StyledDiv>
      ))}
    </SubContainer>
  );
};

const FooterComponent = () => (
  <>
    <div />
    <Footer>
      <FooterGrid />
      <Mini currentYear={getCurrentYear()} />
    </Footer>
  </>
);

export default FooterComponent;
